import { useState, type FormEvent } from 'react';
import {
  Button,
  DialogActions,
  DialogContent,
  TextField,
} from '@mui/material';
import type { SettingsSubcontractorRow } from '../../types';
import { SUBCONTRACTOR_MODAL_LABELS as LABELS  } from '../../../../utils/labels';
import AppDialog from '../../../../components/AppDialog';
import { useModalHistory } from '../../../../utils/useModalHistory';
import SpinnerButton from '../../../../components/SpinnerButton';

interface SubcontractorModalProps {
  subcontractor?: SettingsSubcontractorRow;
  onClose: () => void;
  onSave: (name: string) => Promise<boolean>;
}

export default function SubcontractorModal({ subcontractor, onClose, onSave }: SubcontractorModalProps) {
  useModalHistory(onClose);
  const [name, setName] = useState(subcontractor?.name ?? '');
  const [nameError, setNameError] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!name.trim()) {
      setNameError(LABELS.nameRequired);
      return;
    }
    setSaving(true);
    const ok = await onSave(name.trim());
    setSaving(false);
    if (ok) onClose();
  };

  return (
    <AppDialog open onClose={onClose} maxWidth="xs" fullWidth title={subcontractor ? LABELS.editTitle : LABELS.createTitle} confirmLabel={LABELS.save} confirmFormId="subcontractor-form" confirmDisabled={saving} confirmLoading={saving} testId="subcontractor-modal">
      <form id="subcontractor-form" onSubmit={handleSubmit} noValidate>

        <DialogContent>
          <TextField
            label={LABELS.nameLabel}
            value={name}
            onChange={(e) => { setName(e.target.value); if (nameError) setNameError(''); }}
            required
            autoFocus
            fullWidth
            className="mt-2"
            error={!!nameError}
            helperText={nameError || undefined}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="error" data-testid="cancel-button">{LABELS.cancel}</Button>
          <SpinnerButton type="submit" variant="contained" loading={saving} data-testid="save-button">
            {LABELS.save}
          </SpinnerButton>
        </DialogActions>
      </form>
    </AppDialog>
  );
}
